import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  createRecipeListAction,
  deleteRecipeListsAction,
  getRecipeListAction,
  mergeRecipeListsAction,
  deleteRecipeAction,
} from "./actions";
import { FAVOURITES } from "@/utils/constant";

export interface RecipeListItem {
  user_id: string;
  list_name: string;
  is_deleted: boolean;
  is_default: boolean;
  is_pinned: boolean;
  recipeList: any[];
  productItems: any[];
  originalRecipeList: any[];
  modifiedRecipeList: any[];
  favourite: any;
}
const initialState: RecipeListItem = {
  user_id: "",
  list_name: "",
  is_deleted: false,
  is_default: false,
  is_pinned: false,
  recipeList: [],
  productItems: [],
  originalRecipeList: [],
  modifiedRecipeList: [],
  favourite: {},
};

const addRecipeToListSlice = createSlice({
  name: "addRecipeToList",
  initialState,
  reducers: {
    setRecipeList: (state, action: PayloadAction<any>) => {
      state.recipeList = action.payload;
    },
    setOriginalRecipeList: (state, action: PayloadAction<any>) => {
      state.originalRecipeList = action.payload;
    },
    setModifiedRecipeList: (state, action: PayloadAction<any>) => {
      state.modifiedRecipeList = action.payload;
    },
    setFavourites: (state, action: PayloadAction<any>) => {
      state.favourite = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      createRecipeListAction.fulfilled,
      (state, action: PayloadAction<any>) => {
        // const data =  action?.payload?.data;
        // state.recipeList.push({
        //   id: data.id,
        //   list_name: data.list_name,
        //   recipes: [],
        // });
      }
    );
    builder.addCase(
      getRecipeListAction.fulfilled,
      (state, action: PayloadAction<any>) => {
        // state.recipeList = action?.payload?.data || [];

        // Separate the Favourites list
        const allLists = action?.payload?.data;
        // const favouritesList =
        //   allLists?.find(
        //     (list: { list_name: string }) => list.list_name === FAVOURITES
        //   ) || [];
        const otherLists =
          allLists?.filter(
            (list: { list_name: string }) => list.list_name !== FAVOURITES
          ) || [];

        // state.favourite = favouritesList || null;
        state.recipeList = otherLists;
      }
    );

    builder.addCase(
      deleteRecipeListsAction.fulfilled,
      (state, action: PayloadAction<any>) => {
        // const recipeListIds = action?.payload?.recipeListIds;
        // state.recipeList = state.recipeList.filter(
        //   (item: any) => !recipeListIds.includes(item?.id)
        // );
      }
    );

    builder.addCase(
      deleteRecipeAction.fulfilled,
      (state, action: PayloadAction<any>) => {
        // const data = action?.payload;
        // const { recipeList, recipeIds } = data;
        // const targetList = state.recipeList.find(
        //   (list: any) => list.id === recipeList
        // );
        // if (targetList) {
        //   targetList.recipes = targetList.recipes.filter(
        //     (recipe: any) => !recipeIds.includes(recipe.recipe_id)
        //   );
        // }
      }
    );
    builder.addCase(
      mergeRecipeListsAction.fulfilled,
      (state, action: PayloadAction<any>) => {
        console.log("=======resp===>", action.payload);
      }
    );
  },
});

export const { setRecipeList, setOriginalRecipeList, setModifiedRecipeList, setFavourites } =
  addRecipeToListSlice.actions;
export const addRecipeToListReducer = addRecipeToListSlice.reducer;
